import { render, staticRenderFns } from "./customerPricingReport.vue?vue&type=template&id=0b65ecca&"
import script from "./customerPricingReport.vue?vue&type=script&lang=js&"
export * from "./customerPricingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports